import * as React from 'react';
import * as styles from './TilesView.css';
import { IUser } from '../../interfaces/IUser';
import { ILike } from '../../interfaces/ILike';
import { IMessage } from '../../interfaces/IMessage';
import { ITilesContentElement } from '../../interfaces/ITilesContentElement';
import { TilesContentElement } from './tilesContentElement/tilesContentElement';
import DateTimeService from '../../services/DateTimeService';
import { IFontSlots } from '../../interfaces/IFontSlots';

export interface IProps {
  elements: ITilesContentElement[];
  user?: IUser;
  tenant?: string;
  component?: string;
  instance?: string;
  token?: string;
  source?: string;
  environment?: "Development" | "Test" | "Production";
  width?: number;
  resultSourceId?: string;
  siteCollection?: string;
  listName?: string;
  loading?: boolean;
  likesEnabled?: boolean;
  commentsEnabled?: boolean;
  backgroundColor?: string;
  overlayColor?: string;
  borderColor?: string;
  borderRadius?: number;
  highlightColor?: string;
  itemTitleColor?: string;
  itemTextColor?: string;
  numberOfElements?: number;
  isMobile?: boolean;
  fontSlots?: IFontSlots;
  userLocation?: string;
  onClickEdit?: (content: any) => void;
  onClickOpen?: (content: any) => void;
  onClickPreview?: (content: any) => void;
  onClickCopy?: (content: any) => void;
  onClickDelete?: (content: any) => void;
  likesUpdated?: (likes: ILike[], itemIndex: number) => void;
  commentsUpdated?: (comments: number, itemIndex: number) => void;
  commentsClick?: (message: IMessage) => void;
  showTitle?: boolean;
  showCategories?: boolean;
  showTeaser?: boolean;
  showAuthor?: boolean;
  showStartDate?: boolean;
  showLikes?: boolean;
  showComments?: boolean;
  showCommandBarItems?: boolean;
  messageIsOpen?: boolean;
  showImage?: boolean;
  showUniqueViews?: boolean;
  unReadHighlight?: string;
  showLikesDimmed?: boolean;
  showCommentsDimmed?: boolean;
  showUniqueViewsDimmed?: boolean;
  reactionOptions?: string[];
  showEmojiPickerExpandButton?: boolean;
}


export interface IState {
  selectedIndex: number;
  messageIsOpen: boolean;
}

export class IATilesView extends React.Component<IProps, IState> {
  private dateTimeService = new DateTimeService();

  constructor(props: IProps) {
    super(props);
    this.state = {
      selectedIndex: 0,
      messageIsOpen: false
    };

  }

  public render(): JSX.Element {
    let minHeight = 0;
    const likesShouldBeShown = this.props.likesEnabled && this.props.showLikes;
    const commentsShouldBeShown = this.props.commentsEnabled && this.props.showComments;
    const numberOfElements = this.props.numberOfElements >= 5 ? 5 : this.props.numberOfElements;
    if (likesShouldBeShown && commentsShouldBeShown && this.props.showCommandBarItems) {
      minHeight = minHeight < 122 ? 122 : minHeight;
    }
    if (this.props.showLikes && this.props.showComments && !this.props.showCommandBarItems) {
      minHeight = minHeight < 90 ? 90 : minHeight;
    }
    if (this.props.showLikes && !this.props.showComments && this.props.showCommandBarItems) {
      minHeight = minHeight < 90 ? 90 : minHeight;
    }
    if (!this.props.showLikes && this.props.showComments && this.props.showCommandBarItems) {
      minHeight = minHeight < 90 ? 90 : minHeight;
    }
    let tilesContentElementHeight = 10;
    if (this.props.showTitle) {
      tilesContentElementHeight += 35;
    }
    if (this.props.showTeaser) {
      tilesContentElementHeight += 45;
    }
    if (this.props.showCategories) {
      tilesContentElementHeight += 22;
    }
    if (this.props.showAuthor || this.props.showStartDate) {
      tilesContentElementHeight += 32;
    }
    if (minHeight > tilesContentElementHeight) {
      tilesContentElementHeight = minHeight;
    }
    let tilesContentElements = [];

    if (this.props.elements != undefined && this.props.elements.length > 0) {
      this.props.elements.forEach((element: ITilesContentElement, index) => {
        if (numberOfElements > index) {
          tilesContentElements.push(
            <TilesContentElement
              user={this.props.user}
              numberOfElements={numberOfElements}
              author={element.author}
              id={element.id}
              key={element.id}
              tenant={this.props.tenant}
              component={this.props.component}
              instance={this.props.instance}
              token={this.props.token}
              source={this.props.source}
              index={index}
              item={element.item}
              environment={this.props.environment}
              title={element.title}
              image={element.image}
              iaMessageBgImagesFromBlob={element.iaMessageBgImagesFromBlob}
              iaConfiguration={element.iaConfiguration}
              videoUrl={element.videoUrl}
              teaser={element.teaser}
              categories={element.categories}
              showSkeleton={false}
              likesEnabled={this.props.likesEnabled}
              commentsEnabled={this.props.commentsEnabled}
              startDate={element.startDate}
              backgroundColor={this.props.backgroundColor}
              overlayColor={this.props.overlayColor}
              borderColor={this.props.borderColor}
              borderRadius={this.props.borderRadius}
              highlightColor={this.props.highlightColor}
              itemTextColor={this.props.itemTextColor}
              fontSlots={this.props.fontSlots}
              userLocation={this.props.userLocation}
              likes={element.likes}
              isMobile={this.props.isMobile}
              commentCount={element.commentCount}
              height={tilesContentElementHeight}
              onClickEdit={() => {
                this.props.onClickEdit(element.item);
              }}
              onClickOpen={() => {
                this.props.onClickOpen(element.item);
              }}
              onClickDelete={() => this.props.onClickDelete(element.item)}
              likesUpdated={(likes: ILike[]) => this.props.likesUpdated(likes, index)}
              commentsUpdated={(comments: number) => this.props.commentsUpdated(comments, index)}
              commentsClick={() => this.props.commentsClick(element.item)}
              showTitle={this.props.showTitle}
              showCategories={this.props.showCategories}
              showTeaser={this.props.showTeaser}
              showAuthor={this.props.showAuthor}
              showStartDate={this.props.showStartDate}
              showLikes={this.props.showLikes && !element.iaConfiguration?.disableLikes}
              showComments={this.props.showComments && !element.iaConfiguration?.disableComments}
              showCommandBarItems={this.props.showCommandBarItems}
              showImage={this.props.showImage}
              showUniqueViews={this.props.showUniqueViews}
              uniqueViewsCount={element.uniqueViewsCount}
              isUnread={element.isUnread}
              unReadHighlight={this.props.unReadHighlight}
              showPinIcon={element.showPinIcon}
              showEmojiPickerExpandButton={this.props.showEmojiPickerExpandButton}
              reactionOptions={this.props.reactionOptions}
              showLikesDimmed={this.props.showLikesDimmed && !element.iaConfiguration?.disableLikes}
              showCommentsDimmed={this.props.showCommentsDimmed && !element.iaConfiguration?.isNewsLink && !element.iaConfiguration?.disableComments}
              showUniqueViewsDimmed={this.props.showUniqueViewsDimmed && this.dateTimeService.isOlderThanOneHour(element.startDate)}
            />
          );
        }
      });
    } else if (this.props.loading) {
      for (let i = 0; i < numberOfElements; i++) {
        tilesContentElements.push(
          <TilesContentElement
            user={this.props.user}
            numberOfElements={numberOfElements}
            index={i}
            key={"TilesContentElementSkeleton_" + i}
            tenant={this.props.tenant}
            component={this.props.component}
            instance={this.props.instance}
            token={this.props.token}
            source={this.props.source}
            environment={this.props.environment}
            showSkeleton={true}
            likesEnabled={this.props.likesEnabled}
            commentsEnabled={this.props.commentsEnabled}
            backgroundColor={this.props.backgroundColor}
            overlayColor={this.props.overlayColor}
            borderColor={this.props.borderColor}
            borderRadius={this.props.borderRadius}
            highlightColor={this.props.highlightColor}
            itemTextColor={this.props.itemTextColor}
            isMobile={this.props.isMobile}
            height={tilesContentElementHeight}
            showTitle={this.props.showTitle}
            showCategories={this.props.showCategories}
            showTeaser={this.props.showTeaser}
            showAuthor={this.props.showAuthor}
            showStartDate={this.props.showStartDate}
            showLikes={this.props.showLikes}
            showComments={this.props.showComments}
            showCommandBarItems={this.props.showCommandBarItems}
            showImage={this.props.showImage}
            showUniqueViews={this.props.showUniqueViews}
          />
        );
      }
    }

    const hasLessItemsThanNumberOfElements = this.props.elements?.length < numberOfElements;
    let tilesPatternStyle = "";
    switch (hasLessItemsThanNumberOfElements ? this.props.elements.length : numberOfElements) {
      case 1:
        tilesPatternStyle = styles.IA_tilesPattern1
        break;
      case 2:
        tilesPatternStyle = styles.IA_tilesPattern2
        break;
      case 3:
        tilesPatternStyle = styles.IA_tilesPattern3
        break;
      case 4:
        tilesPatternStyle = styles.IA_tilesPattern4
        break;
      case 5:
        tilesPatternStyle = styles.IA_tilesPattern5
        break;
      default:
        tilesPatternStyle = styles.IA_tilesPattern1
        break;
    }
    return (
      <div
        className={styles.IA_tiles}>
        <div
          className={tilesPatternStyle}
          style={{
            gridGap: this.props.borderRadius ? 5 : 1
          }}
          role="list">
          {tilesContentElements}
        </div>
      </div>
    );
  }


}             